import React from 'react';
import { generatePath, Link } from 'react-router-dom';
import styled from 'styled-components';

import { ROUTES } from '../routes/routes';

const StyledLink = styled(Link)`
  font-weight: 600;
  color: #1a1a1a;
  text-decoration: none;

  &:hover {
    color: #ff8e8e;
  }
`;

interface ProductLinkProps {
  slug: string | number;
  children: React.ReactNode;
  openInNewTab?: boolean;
}

export const ProductLink: React.FC<ProductLinkProps> = ({ slug, children, openInNewTab }) => (
  <StyledLink
    to={generatePath(ROUTES.PRODUCT_VIEW, { slug: String(slug) })}
    target={openInNewTab ? '_blank' : undefined}
    rel={openInNewTab ? 'noopener noreferrer' : undefined}
  >
    {children}
  </StyledLink>
);
